import { post, put } from "../Service/ApiConfig";
import { ApiEndpoints } from "../Service/Endpoints/ApiEndPoints";

export const SendEmailVerification = async ({ emailAddress, language }) => {
  const body = {
    email: emailAddress,
    language: language,
  };
  const response = await post(
    ApiEndpoints.verificationEmail,
    JSON.stringify(body)
  );

  return response;
};

export const sendOtpVerification = async ({ emailAddress, otpCode }) => {
  const body = {
    email: emailAddress,
    OtpToken: otpCode,
  };
  const response = await post(ApiEndpoints.verifyOTP, JSON.stringify(body));
  return response;
};

export const requestResendOtp = async ({ emailAddress, lang }) => {
  const body = {
    email: emailAddress,
    language: lang,
  };
  const response = await put(
    ApiEndpoints.requestResendOtp,
    JSON.stringify(body)
  );
  return response;
};

export const sendCredentialVerfication = async ({ emailAddress, password }) => {
  const body = {
    email: emailAddress,
    password: password,
  };
  const response = await post(ApiEndpoints.verifyLogin, JSON.stringify(body));
  return response;
};

export const sendForgotPasswordEmailVerification = async ({
  emailAddress,
  language,
}) => {
  const body = {
    email: emailAddress,
    language: language,
  };
  const response = await post(
    ApiEndpoints.forgotPasswordVerifyEmail,
    JSON.stringify(body)
  );
  return response;
};

export const resetPassword = async ({
  emailAddress,
  confirmPassword,
  token,
  password,
  expireTime
}) => {
  const body = {
    email: emailAddress,
    confirmPassword: confirmPassword,
    password: password,
    token: token,
    expireTime: expireTime
  };
  const response = await post(
    ApiEndpoints.resetPassword,
    JSON.stringify(body)
  );
  return response;
};

export const resetTokenValidCheck = async ({
  emailAddress,
  token,
}) => {
  const body = {
    email: emailAddress,
    token: token,
  };
  const response = await post(
    ApiEndpoints.resetTokenValidCheck,
    JSON.stringify(body)
  );
  return response;
};
